import React, { useCallback, useEffect, useState } from "react";
import { FaLocationDot } from "react-icons/fa6";
import { MdEmail } from "react-icons/md";
import { MdAccessTimeFilled } from "react-icons/md";
import { IoCallSharp } from "react-icons/io5";
import * as yup from 'yup';
import { useFormik } from "formik";
import { adduserContact } from "./Services/contact";
import { errorToast, successToast } from "./utils/toastMsgs";

const Contact = () => {
    const [width, setWidth] = useState({
        winWidth: window.innerWidth
    });
    const [contactData, setContactData] = useState({
        name: '',
        email: '',
        phone: '',
        message: ''
    });

    const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
    const contactUsSchema = yup.object().shape({
        name: yup.string().required("Name is required"),
        email: yup.string().required("Email is required"),
        phone: yup.string().trim().matches(phoneRegExp, "Phone number is not valid").min(10, "Phone number is not valid.").max(10, "Phone number is not valid.").required("Phone number is required."),
        message: yup.string().required("Message is required"),
    });

    const formik = useFormik({
        initialValues: {
            name: '', email: '', phone: '', message: ''
        },
        validationSchema: contactUsSchema,
        onSubmit: ((values) => {
            setContactData({
                ...contactData,
                name: values.name,
                email: values.email,
                phone: values.phone,
                message: values.message,
            })
        })
    });

    const detectSize = () => {
        setWidth({
            winWidth: window.innerWidth
        })
    }

    const setInputValue = useCallback(
        (key, value) => {
            formik.setValues({
                ...formik.values,
                [key]: value,
            });
            setContactData({
                ...contactData,
                [key]: value
            })
        },
        [formik, contactData]
    );

    const checkDetails = async () => {
        formik.handleSubmit();
        if (contactData?.name && contactData?.email && contactData?.phone && contactData?.message) {
            const contactDetails = await adduserContact(contactData);
            if (contactDetails?.code === 200) {
                successToast("Mail Send Successfully.");
            } else {
                errorToast("Something went to wrong!")
            }
        }
    }

    const clearData = () => {
        setContactData({
            name: '', email: '', phone: '', message: ''
        });
        formik.setValues({
            name: '', email: '', phone: '', message: ''
        })
    }

    useEffect(() => {
        window.addEventListener('resize', detectSize)

        // window.scrollTo(0, 0);

        return (() => {
            window.removeEventListener('resize', detectSize)
        })
    }, [width])

    return (
        <>
            <section className="page-section" id="contact" style={{ userSelect: "none" }}>
                <div className="container">
                    {/* <div className="text-center">
                        <h2 className="section-heading text-uppercase">Contact Us</h2>
                    </div> */}
                    <div style={{ display: "flex", flexDirection: "column", marginBottom: "10px" }}>
                        {width?.winWidth > 768 ?
                            <div className="row">
                                <div className="col-4">
                                    <div style={{ display: "flex", justifyContent: "center" }}>
                                        <FaLocationDot style={{ color: "white", width: "28px", height: "28px" }} className="section-subheading text-muted" />
                                        <h4 style={{ color: "white" }} className="section-subheading text-muted">Location</h4>
                                    </div>
                                    <div style={{ display: "flex", justifyContent: "center", marginBottom: "10px" }}>
                                        <h6 style={{ color: "white" }} className="centerText">27, Devchakra Row House, Next to Anjani Heights, Jahangirpura, Surat, Gujarat, 395005</h6>
                                    </div>
                                </div>

                                <div className="col-4">
                                    <div style={{ display: "flex", justifyContent: "center" }}>
                                        <IoCallSharp style={{ color: "white", width: "28px", height: "28px" }} className="section-subheading text-muted" />
                                        <h4 style={{ color: "white" }} className="section-subheading text-muted">Contact</h4>
                                    </div>
                                    <div style={{ display: "flex", justifyContent: "center", marginBottom: "10px", flexDirection: "column" }}>
                                        <h6 style={{ color: "white", textAlign: "center", marginLeft: "20px" }} className="centerText">Phone: +91 8141096997</h6>
                                        <h6 style={{ color: "white", textAlign: "center", marginLeft: "20px" }} className="centerText">Email: mvnailshouse@gmail.com</h6>
                                    </div>
                                </div>
                                <div className="col-4">
                                    <div style={{ display: "flex", justifyContent: "center" }}>
                                        <MdAccessTimeFilled style={{ color: "white", width: "25px", height: "25px" }} className="section-subheading text-muted" />
                                        <h4 style={{ color: "white" }} className="section-subheading text-muted">Opening Hours</h4>
                                    </div>
                                    <div style={{ display: "flex", justifyContent: "center", marginBottom: "10px", flexDirection: "column" }}>
                                        <h6 style={{ color: "white", textAlign: "center", marginLeft: "20px" }} className="centerText">Monday-Sunday</h6>
                                        <h6 style={{ color: "white", textAlign: "center", marginLeft: "20px" }} className="centerText">10am-8pm</h6>
                                    </div>
                                </div>
                            </div>
                            : <div className="row">
                                <div className="col-12" style={{ marginBottom: "15px" }}>
                                    <div style={{ display: "flex" }}>
                                        <FaLocationDot style={{ color: "white", width: "25px", height: "25px" }} className="section-subheading text-muted" />
                                        <h6 style={{ color: "white", marginLeft: "20px", fontWeight: "unset" }} className="centerText">67, Laxminivas, Darji mohallo, near pantaloons, Adajan Gam, Adajan, Surat, Gujarat 395005</h6>
                                    </div>
                                </div>

                                <div className="col-12">
                                    <div style={{ display: "flex", flexDirection: "column" }}>
                                        <div style={{ marginBottom: "15px" }}>
                                            <IoCallSharp style={{ color: "white", width: "25px", height: "25px" }} className="section-subheading text-muted" />
                                            <a style={{ color: "white", marginLeft: "20px", textDecoration: "none" }} className="centerText" href="tel:+917046662128">+91 8141096997</a>
                                        </div>
                                        <div style={{ marginBottom: "15px" }}>
                                            <MdEmail style={{ color: "white", width: "25px", height: "25px" }} className="section-subheading text-muted" />
                                            <a style={{ color: "white", marginLeft: "20px", textDecoration: "none" }} className="centerText" href="email:+917046662128"> mvnailshouse@gmail.com</a>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12" >
                                    <div style={{ display: "flex", flexDirection: "column" }}>
                                        <div style={{ display: "flex", flexDirection: "row" }}>
                                            <MdAccessTimeFilled style={{ color: "white", width: "25px", height: "25px" }} className="section-subheading text-muted" />
                                            <span style={{ color: "white", marginLeft: "20px", textDecoration: "none", fontWeight: "normal" }} className="centerText">Monday-Sunday</span>
                                        </div>
                                        <div>
                                            <span style={{ color: "white", marginLeft: "20px", textDecoration: "none", fontWeight: "normal", margin: "42px" }} className="centerText">10am-8pm</span>
                                        </div>
                                    </div>
                                </div>
                            </div>}
                    </div>
                    {width?.winWidth < 768 ?
                        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d8628.60724755581!2d72.78846205864286!3d21.193317603010794!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be04d614dae7771%3A0x2e429474c5f609a0!2sMV%20Nails%20House!5e0!3m2!1sen!2sin!4v1707366250591!5m2!1sen!2sin"
                            width="100%"
                            height="510px"
                            // frameBorder={0}
                            style={{ border: 0 }}
                            allowFullScreen=""
                            title="map"
                        />
                        : ''}
                    <div id="contactForm">
                        <div className="row align-items-stretch mb-5">
                            <div className="col-md-6" style={{ marginBottom: "30px" }}>
                                <div style={{ position: "relative" }}>
                                    <div className="form-group">
                                        <input
                                            className="form-control"
                                            id="name"
                                            type="text"
                                            placeholder="Your Name *"
                                            name="name"

                                            value={formik.values.name}
                                            onChange={(e) => setInputValue("name", e.target.value)}
                                            onBlur={formik.handleBlur}
                                        />
                                        <div style={{ position: "absolute" }}>
                                            {formik.errors.name && formik.touched.name ? <span style={{ color: 'red' }}>
                                                {formik.errors.name}
                                            </span>
                                                : null}
                                        </div>
                                    </div>
                                </div>
                                <div style={{ position: "relative" }}>
                                    <div className="form-group">
                                        <input
                                            className="form-control"
                                            id="email"
                                            type="email"
                                            placeholder="Your Email *"
                                            name="email"

                                            value={formik.values.email}
                                            onChange={(e) => setInputValue("email", e.target.value)}
                                            onBlur={formik.handleBlur}
                                        />
                                        <div style={{ position: "absolute" }}>
                                            {formik.errors.email && formik.touched.email ? <span style={{ color: 'red' }}>
                                                {formik.errors.email}
                                            </span>
                                                : null}
                                        </div>
                                    </div>
                                </div>
                                <div style={{ position: "relative" }}>
                                    <div className="form-group">
                                        <input
                                            className="form-control"
                                            id="phone"
                                            type="tel"
                                            placeholder="Your Phone *"
                                            name="phone"

                                            value={formik.values.phone}
                                            onChange={(e) => setInputValue("phone", e.target.value)}
                                            onBlur={formik.handleBlur}
                                        />
                                        <div style={{ position: "absolute" }}>
                                            {formik.errors.phone && formik.touched.phone ? <span style={{ color: 'red' }}>
                                                {formik.errors.phone}
                                            </span>
                                                : null}
                                        </div>
                                    </div>
                                </div>
                                {/* <div style={{ position: "relative" }}> */}
                                <div className="form-group form-group-textarea  mb-md-0 h-50">
                                    <textarea
                                        className="form-control"
                                        id="message"
                                        placeholder="Your Message *"
                                        name="message"

                                        value={formik.values.message}
                                        onChange={(e) => setInputValue("message", e.target.value)}
                                        onBlur={formik.handleBlur}
                                    />
                                    <div style={{ position: "absolute" }}>
                                        {formik.errors.message && formik.touched.message ? <span style={{ color: 'red' }}>
                                            {formik.errors.message}
                                        </span>
                                            : null}
                                    </div>
                                </div>
                                {/* </div> */}
                            </div>
                            {width?.winWidth > 768 ?
                                <div className="col-md-6">
                                    <div style={{ display: "flex", justifyContent: "center" }}>
                                        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d8628.60724755581!2d72.78846205864286!3d21.193317603010794!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be04d614dae7771%3A0x2e429474c5f609a0!2sMV%20Nails%20House!5e0!3m2!1sen!2sin!4v1707366250591!5m2!1sen!2sin"
                                            width="100%"
                                            height="510px"
                                            style={{ border: 0 }}
                                            allowFullScreen=""
                                            title="map"
                                        />
                                    </div>
                                </div>
                                : ''}
                        </div>
                        <div className="text-center">
                            <button
                                className="btn btn-primary btn-xl text-uppercase"
                                // id="submitButton"
                                // type="submit"
                                onClick={() => { checkDetails(); clearData() }}
                            >
                                Send Message
                            </button>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Contact;